import FlightResultCard from '../components/results/FlightResultCard';
import SearchResultsLayout from '../components/SearchResultsLayout';
import { SEARCH_BANNERS } from '../data/mockData';

export default function FlightResultsPage() {
  const summary = (sp) => {
    const from = sp.get('from') || 'Anywhere';
    const to = sp.get('to') || 'Anywhere';
    const trip = sp.get('trip') || 'roundtrip';
    const depart = sp.get('depart') || 'Flexible';
    return `${from} → ${to} · ${trip} · Depart ${depart}`;
  };

  return (
    <SearchResultsLayout
      type="flights"
      bannerImage={SEARCH_BANNERS.flights}
      title="Flight Search Results"
      summary={summary}
      renderCard={(item, searchParams) => (
        <FlightResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
